import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { persistCombineReducers } from 'redux-persist';
import { Reducer } from 'redux';

import authReducer, { AuthReducer } from './authReducer';
import toastsReducer, { ToastsReducer } from './toastsReducer';
import productCategoryReducer, { ProductCategoriesReducer } from './productCategoryReducer';
import fileReducer, { FileReducer } from './fileReducer';
import listReducer, { ListsReducer } from './listReducer';

const config = {
    key: 'grby_root',
    storage,
    blacklist: ['toasts'],
};

export interface ApplicationState {
    auth: AuthReducer;
    toasts: ToastsReducer;
    productCategories: ProductCategoriesReducer;
    file: FileReducer;
    lists: ListsReducer;
}

const rootReducer: Reducer<ApplicationState> = persistCombineReducers<ApplicationState>(config, {
    auth: authReducer,
    toasts: toastsReducer,
    productCategories: productCategoryReducer,
    lists: listReducer,
    file: fileReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.ts